import DogKennelAlternative from './DogKennelAlternative';

export default DogKennelAlternative;
